import pako from 'pako' // Si usas npm

const DB_NAME = 'AutodeskViewerCache'
const STORE_NAME = 'ExternalIdMappings'

const CHUNK_SIZE = 10000 // Fragmentar en trozos de 10,000 claves

// Fragmentar el objeto en trozos más pequeños
const chunkObject = obj => {
  const keys = Object.keys(obj)
  const chunks = []

  for (let i = 0; i < keys.length; i += CHUNK_SIZE) {
    const chunk = {}
    for (let j = i; j < i + CHUNK_SIZE && j < keys.length; j++) {
      chunk[keys[j]] = obj[keys[j]]
    }
    chunks.push(chunk)
  }

  return chunks
}

// Comprimir los datos
const compressData = obj => {
  const stringifiedData = JSON.stringify(obj)
  return pako.deflate(stringifiedData, { to: 'string' }) // Comprimir a cadena
}

// Descomprimir los datos
const decompressData = compressedData => {
  const decompressed = pako.inflate(compressedData, { to: 'string' })
  return JSON.parse(decompressed) // Convertir de nuevo en objeto
}

// Abrir la base de datos IndexedDB
const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)
    request.onupgradeneeded = event => {
      const db = event.target.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME)
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = event => reject(event.target.error)
  })
}

// Obtener todos los fragmentos de IndexedDB
const getAllIndexedDbChunks = async key => {
  try {
    const db = await openDB()
    const transaction = db.transaction(STORE_NAME, 'readonly')
    const store = transaction.objectStore(STORE_NAME)

    // Obtener todas las claves del store
    const allKeys = await new Promise((resolve, reject) => {
      const request = store.getAllKeys()
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => reject('Error obteniendo claves de IndexedDB')
    })

    // Filtrar solo las claves que empiezan con "key"
    const chunkKeys = allKeys.filter(
      k => typeof k === 'string' && k.startsWith(`${key}-chunk-`)
    )

    if (chunkKeys.length === 0) {
      console.log('No hay fragmentos en IndexedDB para la key:', key)
      return []
    }

    // Obtener los datos de todas las claves filtradas
    const chunkRequests = chunkKeys.map(chunkKey => {
      return new Promise((resolve, reject) => {
        const req = store.get(chunkKey)
        req.onsuccess = () => resolve(decompressData(req.result))
        req.onerror = () => reject(`Error leyendo fragmento ${chunkKey}`)
      })
    })

    const chunks = await Promise.all(chunkRequests)

    return chunks
  } catch (error) {
    console.error('Error en getAllIndexedDbChunks:', error)
    return []
  }
}

// Guardar datos en IndexedDB
const saveToIndexedDB = (key, data) => {
  return new Promise(async (resolve, reject) => {
    const db = await openDB()
    const transaction = db.transaction(STORE_NAME, 'readwrite')
    const store = transaction.objectStore(STORE_NAME)

    // Fragmentar y comprimir los datos antes de guardarlos
    const chunks = chunkObject(data)
    chunks.forEach((chunk, index) => {
      const compressedChunk = compressData(chunk)
      store.put(compressedChunk, `${key}-chunk-${index}`)
    })

    transaction.oncomplete = () => resolve()
    transaction.onerror = () => reject('Error saving to IndexedDB')
  })
}

export const IndexedDB = { getAllIndexedDbChunks, saveToIndexedDB }
